import { Stack, type StackProps } from "@mui/material";
import type React from "react";
import { TagChip } from "./tag-chip";

export interface TagListProps extends Omit<StackProps, "children"> {
  tags: string[];
  size?: "small" | "medium";
  variant?: "filled" | "outlined";
  showDeleteIcon?: boolean;
  onDelete?: (tag: string) => void;
  maxDisplay?: number;
  spacing?: number;
}

export const TagList: React.FC<TagListProps> = ({
  tags,
  size = "small",
  variant = "outlined",
  showDeleteIcon = false,
  onDelete,
  maxDisplay,
  spacing = 1,
  ...stackProps
}) => {
  if (!tags || tags.length === 0) {
    return null;
  }

  const displayTags = maxDisplay ? tags.slice(0, maxDisplay) : tags;
  const remainingCount = maxDisplay ? tags.length - maxDisplay : 0;

  return (
    <Stack direction="row" spacing={spacing} alignItems="center" flexWrap="wrap" {...stackProps}>
      {displayTags.map((tag) => (
        <TagChip
          key={tag}
          tag={tag}
          size={size}
          variant={variant}
          showDeleteIcon={showDeleteIcon}
          onDelete={onDelete}
        />
      ))}
      {remainingCount > 0 && (
        <TagChip
          tag={`+${remainingCount}`}
          size={size}
          variant="outlined"
          sx={{
            backgroundColor: "grey.100",
            borderColor: "grey.500",
            color: "grey.700",
            cursor: "pointer",
          }}
        />
      )}
    </Stack>
  );
};
